<template>
  <div>
    <a-list item-layout="horizontal" :data-source="qas">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-form-model :model="form" :rules="rules" ref="ruleForm">
          <a-list-item-meta>
            <a-form-model-item
              slot="description"
              label="Answer / Hướng dẫn"
              prop="answer"
              v-if="edittingItem === item.id"
            >
              <VueEditor
                class="ict24h-editor"
                :editor-toolbar="customToolbar"
                placeholder="Nhập hướng dẫn..."
                v-model="form.answer"
              />
              <div style="margin-top: 10px; text-align: right;">
                <a-button style="margin-right: 5px;" @click="edittingItem = ''">
                  Close
                </a-button>
                <a-button
                  type="primary"
                  :loading="loadingBtn"
                  @click="onSubmit"
                >
                  Update
                </a-button>
              </div>
            </a-form-model-item>
            <div
              v-else
              class="ql-editor"
              slot="description"
              v-html="item.answer"
              style="padding: 0;"
            ></div>
            <div v-if="edittingItem === item.id" slot="title">
              <a-form-model-item
                slot="description"
                v-if="edittingItem === item.id"
                label="Question / Câu hỏi"
                prop="question"
              >
                <a-input v-model="form.question" placeholder="Enter text..." />
              </a-form-model-item>
            </div>
            <a v-else slot="title">
              <span class="ant-descriptions-title">
                {{ item.question }}
              </span>

              <span style="float: right;">
                <a-button
                  v-if="edittingItem !== item.id"
                  icon="edit"
                  type="link"
                  @click="onEdittingItem(item)"
                ></a-button>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="Confirm action?"
                  ok-text="Delete"
                  cancel-text="No"
                  @confirm="onDeletedHelpdeskQA(item)"
                  placement="topLeft"
                >
                  <a-button
                    v-if="edittingItem !== item.id"
                    :loading="loadingBtn"
                    icon="delete"
                    type="link"
                    style="color: red;"
                  ></a-button>
                </a-popconfirm>
              </span>
            </a>
          </a-list-item-meta>
        </a-form-model>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
import query from "../constant/query";
const rules = {
  question: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "change",
    },
  ],
  answer: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "change",
    },
  ],
};
export default {
  props: {
    qas: {
      type: Array,
      default: () => {
        return [];
      },
    },
    idHelpdesk: {
      type: String,
      required: true,
    },
    refreshAfterUpdatedQA: {
      type: Function,
      default: () => {},
    },
    refreshAfterDeletedQA: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      rules,
      edittingItem: "",
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      form: {},
      loadingBtn: false,
    };
  },
  methods: {
    onEdittingItem(item) {
      if (item?.id) {
        this.edittingItem = item.id;
        this.form = { ...item };
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdateHelpdeskQA();
        } else {
          return false;
        }
      });
    },
    onUpdateHelpdeskQA() {
      this.loadingBtn = true;
      if (!this.idHelpdesk) {
        throw new Error("Cannot find id heldesk category");
      }
      this.$apollo
        .mutate({
          mutation: query.updateHelpdeskQA,
          variables: {
            id: this.form.id,
            categoryId: this.idHelpdesk,
            question: this.form.question,
            answer: this.form.answer,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Cập nhật danh mục hỗ trợ thành công!",
          });
          this.loadingBtn = false;
          this.edittingItem = "";
          if (data?.updateHelpdeskQA?.id) {
            this.refreshAfterUpdatedQA(data.updateHelpdeskQA);
          }
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Cập nhật danh mục hỗ trợ không thành công!",
          });
          console.log("Cập nhật danh mục hỗ trợ không thành công", err);
        });
    },
    onDeletedHelpdeskQA(item) {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.deleteHelpdeskQA,
          variables: {
            id: item.id,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Xóa danh mục hỗ trợ thành công!",
          });
          this.loadingBtn = false;
          if (data?.deleteHelpdeskQA?.id) {
            this.refreshAfterDeletedQA(data.deleteHelpdeskQA);
          }
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Xóa danh mục hỗ trợ không thành công!",
          });
          console.log("Xóa danh mục hỗ trợ không thành công", err);
        });
    },
  },
};
</script>
<style lang="css" scoped></style>
